import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthTokenService {
  private readonly accessTokenKey = 'Daro_Auth_AccessToken';

  getAccessToken(): string | null {
    const value = localStorage.getItem(this.accessTokenKey);
    return value && value.trim() ? value : null;
  }

  storeAccessToken(accessToken: string): void {
    if (accessToken && accessToken.trim()) {
      localStorage.setItem(this.accessTokenKey, accessToken);
    } else {
      localStorage.removeItem(this.accessTokenKey);
    }
  }

  storeLoginResponse(response: any): void {
    if (!response) {
      return;
    }

    if (response.accessToken) {
      this.storeAccessToken(response.accessToken);
    } else {
      localStorage.removeItem(this.accessTokenKey);
    }

  }

  clearAuthentication(): void {
    [
      this.accessTokenKey,
      'Daro_User_UserImage',
      'Daro_User_Fullname',
      'Daro_User_Type',
      'Daro_User_TokenStation',
      'Daro_User_CanLetterHistory',
      'Daro_User_Nav'
    ].forEach(key => localStorage.removeItem(key));
  }
}
